import SimpleImg from '../assets/images/cards/simpleImg1.svg';
import AccessibleImg from '../assets/images/cards/AccessibleImg1.svg';
import PrivateImg from '../assets/images/cards/PrivateImg2.svg';
import ProprietaryImg from '../assets/images/cards/ProprietaryImg1.svg';
import Button from './Button';
import { motion } from "framer-motion";

const PrivatePoolsCards = () => {

    const opportunities = [
        {
            title: '01 For Traders',
            text: 'MondrianSwap offers deep liquidity, low slippage, and optimized trade execution using Balancer’s Smart Order Router (SOR). Enjoy efficient swaps across multiple assets with minimal fees.',
            img: SimpleImg
        },
        {
            title: '02 For Investors',
            text: 'Earn passive income by providing liquidity to MondrianSwap’s dynamic pools. Benefit from flexible exposure to multiple assets and optimized yield strategies.',
            img: AccessibleImg
        },
        {
            title: '03 Weighted Pools',
            text: 'Unlike traditional AMMs, MondrianSwap allows custom weight allocations (e.g., 80/20 or 50/50), enabling tailored risk management and capital efficiency for liquidity providers.',
            img: PrivateImg
        },
        {
            title: '04 Custom Pools',
            text: 'MondrianSwap empowers liquidity providers with fully customizable pools, allowing tailored asset weightings, dynamic fee structures, and specialized trading strategies.',
            img: ProprietaryImg
        },
    ];

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        return {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        };
    };

    return (
        <>
            <div className='px-[5%] mt-[450px] xl:mt-[300px]'>
                <div className='flex flex-row sm:flex-col md:flex-row justify-between items-start gap-8'>
                    <motion.div {...animation(0.4, -250, 0, 0, 0)} 
                        className='text-8xl sm:text-6xl xl:text-6xl uppercase font-bold'>
                        our features
                    </motion.div>
                    <motion.div {...animation(0.4, 250, 0, 0, 0)} 
                        className='w-1/2 sm:w-full md:w-1/2 font-[Plus Jakarta Sans] text-2xl leading-relaxed text-[#BABABA] font-normal'>
                        MondrianSwap is a DEX offering Weighted Pools for flexible token allocations, Stable Pools for low-slippage stablecoin trades, and Smart Order Routing for optimal pricing.
                    </motion.div>
                </div>
                <div className='flex justify-between flex-col mt-32'>
                    {opportunities.map((el, i) => (
                        <>
                            <hr className='border-[1px] border-[#334756]' />
                            <div className='py-32'>
                                <div className='flex sm:flex-col md:flex-row justify-between items-center gap-8'>
                                    {/* Image - Moves on top for mobile */}
                                    <motion.div {...animation(0.5, 150, 0, 0, 0)} className='flex flex-col justify-between gap-4 sm:order-first'>
                                        <div className='min-w-[200px]'>
                                            <img src={el.img} className='w-full max-w-[800px]' />
                                        </div>
                                    </motion.div>

                                    {/* Text Content */}
                                    <motion.div {...animation(0.5, -150, 0, 0, 0)} 
                                        className='flex flex-col justify-between sm:text-center md:text-left sm:items-center md:items-start'>
                                        <div className='font-[Plus Jakarta Sans] text-3xl font-semibold'>{el.title}</div>
                                        <div className='font-[Plus Jakarta Sans] text-lg leading-relaxed text-[#BABABA] font-normal w-full sm:w-[90%] md:w-1/2'>
                                            {el.text}
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        </>
                    ))}
                    <hr className='border-[1px] border-[#334756]' />
                </div>
            </div>
        </>
    );
};

export default PrivatePoolsCards;
